<template>
	<div class="details-container">
		<div class="content-container">
			<BreadCrumb :routerLinks="routerLinks" currentTitle="详情"></BreadCrumb>
			<div class="marketsInfo">
				<div class="image-gallery">
					<div class="thumbnails-box">
						<button class="prev-btn" @click="prevImage">
							<img src="../assets/Markets/iconA.png">
						</button>
						<div class="thumbnails-container" ref="thumbnailContainer">
							<div class="thumbnails">
								<div class="thumbnail" v-for="(image, index) in images" :key="index"
									:class="{ active: image.img === selectedImage.img }" @click="selectImage(image)">
									<img :src="image.img" alt="Thumbnail" />
									<img class="videoPlayIcon" src="../assets/MyOrder/iconK.png"
										v-if="image.type == 'video'" />
								</div>
							</div>
						</div>
						<button class="next-btn" @click="nextImage">
							<img src="../assets/Markets/iconB.png">
						</button>
					</div>
					<div class="main-image" v-if="selectedImage.img">
						<img :src="selectedImage.img" v-show="selectedImage.type == 'img'" />
						<video ref="myVideo" controls style="width: 5rem;height: 5rem;" :poster="selectedImage.img"
							:src="selectedImage.url" v-show="selectedImage.type == 'video'"></video>
					</div>
				</div>
				<div class="otherInfo">
					<div class="title">
						{{details.title ? details.title : ''}}
					</div>
					<div class="subTitle">
						{{details.content ? details.content : ''}}
					</div>
					<div class="tips">
						<div class="tip">
							{{details.cid ? details.cid : ''}}
						</div>
						<div class="tip">
							{{details.guige ? details.guige : ''}}
						</div>
					</div>
					<div class="priceBuyCount">
						<div class="price">
							<span class="unit">¥</span>
							{{details.original_price ? details.original_price : 0}}
						</div>
						<div class="buyCount">已售{{details.buy_count ? details.buy_count : 0}}+</div>
						<img src="../assets/Markets/iconC.png">
					</div>
					<div class="make" @click="naviToMarketBuy">立即定制</div>
				</div>
			</div>
		</div>
		<div class="detail">
			<div class="subTilte">
				商品详情
			</div>
			<div class="rihText" v-html="details.details">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MarketsDetails',
		data() {
			return {
				images: [],
				selectedImage: {},
				scrollPosition: 0, // 控制滚动位置
				thumbnailsPerPage: 4, // 每页显示的缩略图数量
				routerLinks: [{
					path: '/surrounding-markets',
					title: '周边市场',
					query: {}
				}],
				details: {},
			}
		},
		mounted() {
			this.activityDetails()
		},
		methods: {
			selectImage(image) {
				this.selectedImage = image; // 点击缩略图时，更新主图像
				this.scrollToImage(image); // 点击缩略图时自动滚动
			},
			prevImage() {
				const currentIndex = this.images.findIndex(item => item.img == this.selectedImage.img);
				const prevIndex = (currentIndex - 1 + this.images.length) % this.images.length;
				this.selectedImage = this.images[prevIndex]; // 切换到上一张图片
				this.scrollToImage(this.selectedImage); // 切换图片时自动滚动
			},
			nextImage() {
				const currentIndex = this.images.findIndex(item => item.img == this.selectedImage.img);
				const nextIndex = (currentIndex + 1) % this.images.length;
				this.selectedImage = this.images[nextIndex]; // 切换到下一张图片
				this.scrollToImage(this.selectedImage); // 切换图片时自动滚动
			},
			scrollToImage(image) {
				this.$refs.myVideo.pause();
				const container = this.$refs.thumbnailContainer;
				const currentIndex = this.images.findIndex(item => item.img == image.img);
				const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
				const thumbnailHeight = 1.14 * rootFontSize; // 每个缩略图的高度，包括间隔
				const maxVisibleThumbnails = 4; // 显示的最大缩略图数量

				// 计算当前选中缩略图的偏移量
				const thumbnailOffset = currentIndex * thumbnailHeight;

				// 计算需要滚动的距离，保持最多显示4个缩略图
				if (thumbnailOffset >= container.scrollTop + maxVisibleThumbnails * thumbnailHeight) {
					container.scrollTop = thumbnailOffset - maxVisibleThumbnails * thumbnailHeight + thumbnailHeight;
				} else if (thumbnailOffset < container.scrollTop) {
					container.scrollTop = thumbnailOffset;
				}
			},
			activityDetails() {
				this.$api.post('/Goods/goods_details', {
					goods_id: this.$route.query.id,
				}).then(res => {
					if (res.code == 1) {
						this.details = res.data
						if (this.details.video) {
							this.images.push({
								id: 1,
								img: this.details.img,
								url: this.details.video,
								type: 'video'
							})
						}
						this.details.banner.forEach(item => {
							this.images.push({
								id: this.images.length + 1,
								img: item,
								url: item,
								type: 'img'
							})
						})
						console.log(this.images)
						this.selectedImage = this.images.length ? this.images[0] : {}
						this.details.details = this.formatRichText(this.details.details)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			naviToMarketBuy() {
				if (localStorage.getItem('token')) {
					this.$router.push({
						path: '/markets-buy',
						query: {
							id: this.details.id
						}
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			formatRichText(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					match = match.replace(/style=""/gi, '').replace(/style=''/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match) {
					match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi,
						'width:100%;');
					return match;
				});
				newContent = newContent.replace(/<img/gi,
					'<img style="width:100%;height:auto;display:block;margin:10px 0;"');

				return newContent;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.details-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		width: 12rem;
	}


	.marketsInfo {
		margin-top: .2rem;
		display: flex;
		width: 12rem;
		height: 5.64rem;
		background: #FFFFFF;
		padding: .32rem .32rem;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
	}

	.otherInfo {
		display: flex;
		flex-direction: column;
		margin-left: .32rem;
		height: 5rem;
		position: relative;

		.make {
			position: absolute;
			bottom: .12rem;
			left: 0;
			width: 2.60rem;
			height: .52rem;
			background: #E29358;
			border-radius: .06rem;
			font-weight: 500;
			font-size: .15rem;
			color: #252525;
			line-height: .52rem;
			text-align: center;
			cursor: pointer;
		}

		.title {
			margin-top: .12rem;
			font-weight: 700;
			font-size: .24rem;
			color: #000000;
			line-height: .32rem;
		}

		.subTitle {
			margin-top: .06rem;
			font-weight: 400;
			font-size: .14rem;
			color: #333333;
		}

		.tips {
			margin-top: .12rem;
			display: flex;
			align-items: center;

			.tip {
				margin-right: .16rem;
				height: .26rem;
				padding: 0 .08rem;
				border-radius: .13rem;
				border: .01rem solid #A88653;
				font-weight: 400;
				font-size: .12rem;
				color: #7C3E0B;
				line-height: .26rem;
			}
		}

		.priceBuyCount {
			margin-top: .24rem;
			width: 4.45rem;
			height: .74rem;
			background: #FF0000;
			border-radius: .06rem;
			padding: .12rem .2rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			position: relative;

			.price {
				display: flex;
				align-items: baseline;
				font-weight: 700;
				font-size: .24rem;
				color: #FFFFFF;
				line-height: .24rem;

				.unit {
					margin-right: .02rem;
					font-weight: 400;
					font-size: .14rem;
				}
			}

			.buyCount {
				font-weight: 400;
				font-size: .14rem;
				color: #FFFFFF;
			}

			img {
				position: absolute;
				width: .5rem;
				height: .5rem;
				top: .12rem;
				right: .5rem;
			}
		}
	}

	.activityInfoBox {
		width: 100%;
		height: 3.96rem;
		background: #FFFFFF;

		.activityInfos {
			margin: .48rem auto;
			width: 12rem;
			display: flex;
			align-items: center;

			.activityImage {
				width: 5.92rem;
				height: 3rem;
				border-radius: .08rem;
				object-fit: cover;
				overflow: hidden;
			}

			.activityInfo {
				margin-left: .32rem;
				height: 3rem;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.activityTitle {
					margin-top: .06rem;
					margin-bottom: .12rem;
					font-weight: 500;
					font-size: .24rem;
					color: #693200;
					line-height: .36rem;
				}

				.activityDesc {
					width: 6rem;
					font-size: .14rem;
					color: #333333;
					line-height: .2rem;
				}

				.tiemBox {
					display: flex;
					flex-direction: column;

					.activityTime,
					.activityEndTime,
					.activityPublishTime {
						font-weight: 400;
						font-size: .14rem;
						color: #999999;
						line-height: .22rem;
					}
				}

				.signUp {
					width: 2.60rem;
					height: .52rem;
					border-radius: .06rem;
					font-weight: 500;
					font-size: .16rem;
					color: #252525;
					text-align: center;
					line-height: .52rem;
					cursor: pointer;
				}

				.active {
					background: #E29358;
				}

				.normal {
					background: #CCCCCC;
				}
			}
		}
	}

	.detail {
		margin: .32rem auto .9rem;
		width: 12rem;

		.subTilte {
			margin: 0 0 .2rem;
			font-weight: 500;
			font-size: .18rem;
			color: #000000;
			line-height: .26rem;
		}
	}


	.reportDialog {

		::v-deep .el-dialog {
			width: 7.40rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.reportContent {
					position: relative;

					.textNum {
						position: absolute;
						right: .12rem;
						bottom: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #999999;
						line-height: .2rem;

						span {
							color: #252525;
						}
					}
				}

				.el-form {

					&-item:nth-child(2) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__content {

							.el-textarea {
								&__inner {
									width: 6rem;
									height: 1.6rem;
									background: #FFFFFF;
									border-radius: .04rem;
									border: .01rem solid #EFD8B8;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
					}
				}
			}
		}
	}
</style>
<style scoped lang="scss">
	.image-gallery {
		display: flex;
		align-items: center;
	}

	.thumbnails-box {
		height: 5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
	}

	.main-image {
		display: flex;
		align-items: center;
		position: relative;
	}

	.main-image img {
		width: 5rem;
		height: 5rem;
		object-fit: cover;
		border-radius: .1rem;
		margin-left: .16rem;
	}

	.prev-btn,
	.next-btn {
		position: absolute;
		width: .5rem;
		height: .14rem;
		padding: 0 0;

		img {
			width: .5rem;
			height: .14rem;
		}
	}

	.prev-btn {
		top: 0;
	}

	.next-btn {
		bottom: 0;
	}

	.thumbnails-container {
		height: 4.46rem;
		overflow-y: auto;
		margin-top: .24rem;
	}

	.thumbnails-container::-webkit-scrollbar {
		display: none;
	}

	.thumbnails-container {
		scrollbar-width: none;
	}

	.thumbnails {
		display: flex;
		flex-direction: column;
	}

	.thumbnail {
		cursor: pointer;
		width: 1.04rem;
		height: 1.04rem;
		margin-bottom: .1rem;
		position: relative;

		.videoPlayIcon {
			position: absolute;
			top: .26rem;
			left: .26rem;
			width: .52rem;
			height: .52rem;
			border: none !important;
		}
	}

	.thumbnail img {
		width: 1.04rem;
		height: 1.04rem;
		object-fit: cover;
		border-radius: .08rem;
		/* transition: transform 0.3s; */
	}

	/* .thumbnail:hover img {
		transform: scale(1.1);
	} */

	.thumbnail.active img {
		border: .02rem solid #f39c12;
		/* 激活状态的缩略图边框 */
	}

	.prev-page-btn,
	.next-page-btn {
		margin-top: 10px;
		padding: 10px;
		background-color: #f39c12;
		color: white;
		border: none;
		cursor: pointer;
		font-size: 16px;
		border-radius: 5px;
		transition: background-color 0.3s;
	}

	.prev-page-btn:hover,
	.next-page-btn:hover {
		background-color: #e67e22;
	}
</style>